import { useContext } from "react";

import { createStackContext } from "src/convenience/stack";

import { type WorkoutItemLayout } from "./WorkoutEditStore";

export const draftWorkoutItemStackContext = createStackContext<string>();

export function useDraftWorkoutItemStackContext() {
  return useContext(draftWorkoutItemStackContext);
}

export type ExerciseDraftViewProps = {
  index: number;
  workoutItemId: string;
};

export interface DraftWorkoutItemViewProps {
  level: number;
  index: number;
  layout: WorkoutItemLayout;
}
